// extracted by mini-css-extract-plugin
export var container = "index-module--container--+M3Vq";
export var videoPreview = "index-module--videoPreview--l+ch7";